
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({})
export default class TruckCommodity extends Vue {
  @Prop({ default: () => [] })
  summary: any[];

  formatValue(value: number) {

  }
}
